export const CITY_ROUTE_ENTRIES = [
  { ru: 'Ростов-на-Дону', slug: 'rostov-na-donu', center_coordinates: [47.2248606, 39.7022858], population : 933_900 },
  { ru: 'Казань', slug: 'kazan', center_coordinates: [55.796127, 49.106405], population : 977_100 },
  { ru: 'Пермь', slug: 'perm', center_coordinates: [58.010386, 56.229496], population : 642_954 },
  { ru: 'Екатеринбург', slug: 'ekaterinburg', center_coordinates: [56.835146, 60.609602], population : 1_198_223 },
  { ru: 'Сочи', slug: 'sochi', center_coordinates: [43.5855, 39.7231], population : 439_920 },
  { ru: 'Нижний Новгород', slug: 'nizhny', center_coordinates: [56.3269, 44.0059], population : 939_888 },
  { ru: 'Краснодар', slug: 'krasnodar', center_coordinates: [45.0355, 38.9753], population : 933_719 },
  { ru: 'Самара', slug: 'samara', center_coordinates: [53.1959, 50.1002], population : 950_340 },
  { ru: 'Уфа', slug: 'ufa', center_coordinates: [54.7388, 55.9721], population : 953_909 },
  { ru: 'Волгоград', slug: 'volgograd', center_coordinates: [48.7080, 44.5133], population : 835_496 },
  { ru: 'Воронеж', slug: 'voronezh', center_coordinates: [51.6720, 39.1843], population : 858_068 },
];

const RU_TO_SLUG = new Map(CITY_ROUTE_ENTRIES.map((entry) => [entry.ru, entry.slug]));
const SLUG_TO_RU = new Map(CITY_ROUTE_ENTRIES.map((entry) => [entry.slug, entry.ru]));

export const AVAILABLE_CITIES_RU = CITY_ROUTE_ENTRIES.map((entry) => [entry.ru, entry.center_coordinates, entry.population] );

/** Симуляционный парк; конечный OTS города = (население 18+ / FLEET) * сырой OTS. */
export const FLEET_CARS_DENOM = 30_000;

export function scaleCityOts(rawOts, population18, fleet = FLEET_CARS_DENOM) {
  const ots = Number(rawOts) || 0;
  const pop = Number(population18) || 0;
  const denom = Number(fleet) || 0;
  if (!(pop > 0) || !(denom > 0)) return ots;
  return ots * (pop / denom);
}

const CITY_SAMPLE_CSV = {
  'rostov-na-donu': {
    href: '/example_banners_file.csv',
    download: 'example_banners_rostov.csv',
  },
  kazan: {
    href: '/example_banners_kazan_only_A_max100_spread.csv',
    download: 'example_banners_kazan.csv',
  },
  ekaterinburg: {
    href: '/example_banners_ekaterinburg.csv',
    download: 'example_banners_ekaterinburg.csv',
  },
  perm: {
    href: '/example_banners_perm.csv',
    download: 'example_banners_perm.csv',
  },
  sochi: {
    href: '/example_banners_sochi_car_spread.csv',
    download: 'example_banners_sochi.csv',
  },
  nizhny: {
    href: '/example_banners_nizhny.csv',
    download: 'example_banners_nizhny.csv',
  },
  krasnodar: {
    href: '/example_banners_krasnodar.csv',
    download: 'example_banners_krasnodar.csv',
  },
  samara: {
    href: '/example_banners_samara.csv',
    download: 'example_banners_samara.csv',
  },
  ufa: {
    href: '/example_banners_ufa.csv',
    download: 'example_banners_ufa.csv',
  },
  volgograd: {
    href: '/example_banners_volgograd.csv',
    download: 'example_banners_volgograd.csv',
  },
  voronezh: {
    href: '/example_banners_voronezh.csv',
    download: 'example_banners_voronezh.csv',
  },
};

export function getCitySampleCsv(cityNameOrSlug) {
  const slug = cityToSlug(cityNameOrSlug)
    || String(cityNameOrSlug || '').trim().toLowerCase();
  return CITY_SAMPLE_CSV[slug] || null;
}

export function cityToSlug(cityNameRu) {
  if (!cityNameRu) return '';
  const fromRu = RU_TO_SLUG.get(cityNameRu);
  if (fromRu) return fromRu;
  const asSlug = String(cityNameRu).trim().toLowerCase();
  return SLUG_TO_RU.has(asSlug) ? asSlug : '';
}

export function citySlugToRu(citySlug) {
  if (!citySlug) return '';
  const normalized = String(citySlug).trim().toLowerCase();
  return SLUG_TO_RU.get(normalized) || '';
}

export function ensureCitySlug(value) {
  if (!value) return '';
  const asRu = cityToSlug(value);
  if (asRu) return asRu;
  const asSlug = citySlugToRu(value);
  if (asSlug) return String(value).trim().toLowerCase();
  return '';
}
